import * as React from "react";
import { Check } from "lucide-react";
import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
import { Card, CardHeader, CardTitle, CardDescription, CardContent } from "@/components/ui/card";
const columns = [{
  id: "comfort",
  title: "Patient Comfort",
  description: "Experience a non-invasive treatment designed for a restful, mask-free night.",
  accentClass: "border-t-primary"
}, {
  id: "portability",
  title: "Travel & Portability",
  description: "Maintain your sleep health anywhere with a compact, cordless solution.",
  accentClass: "border-t-chart-2"
}, {
  id: "compliance",
  title: "Clinical Success",
  description: "Higher adherence rates lead to better long-term health outcomes.",
  accentClass: "border-t-chart-3"
}];
const benefits = [{
  columnId: "comfort",
  text: "Custom-fitted by dental sleep specialists"
}, {
  columnId: "comfort",
  text: "No restrictive masks or bulky headgear"
}, {
  columnId: "comfort",
  text: "Freedom to sleep in any natural position"
}, {
  columnId: "comfort",
  text: "Silent operation for you and your partner"
}, {
  columnId: "portability",
  text: "Compact enough to fit in your pocket"
}, {
  columnId: "portability",
  text: "No electricity or batteries required"
}, {
  columnId: "portability",
  text: "Perfect for flights and hotel stays"
}, {
  columnId: "portability",
  text: "Simplified cleaning and maintenance"
}, {
  columnId: "compliance",
  text: "90% higher adherence than CPAP machines"
}, {
  columnId: "compliance",
  text: "Immediate reduction in nightly snoring"
}, {
  columnId: "compliance",
  text: "Clinically proven to reduce apnea events"
}, {
  columnId: "compliance",
  text: "Lower risk of cardiovascular complications"
}];
export default function BenefitsOverview() {
  return <section data-section-id="132675" id="why-choose-oral-therapy" className="py-24 bg-background text-foreground">
      <div className="container mx-auto px-4 md:px-6">
        <div className="text-center max-w-3xl mx-auto mb-16">
          <h2 className="text-3xl md:text-4xl font-bold text-primary mb-4 tracking-tight">
            Why Choose Oral Appliance Therapy?
          </h2>
          <p className="text-lg text-muted-foreground">
            Oral appliances offer a modern, evidence-based alternative to traditional treatments, focusing on patient comfort and lifestyle flexibility without compromising clinical results.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          {columns.map((col, i) => <div key={col.id} data-index={i} className="flex">
              <Card className={`w-full flex flex-col rounded-[12px] shadow-xl border-x-0 border-b-0 border-t-4 ${col.accentClass} hover:-translate-y-2 transition-transform duration-300 bg-card`}>
                <CardHeader className="pb-4">
                  <CardTitle className="text-2xl font-bold text-foreground">
                    {col.title}
                  </CardTitle>
                  <CardDescription className="text-base mt-2">
                    {col.description}
                  </CardDescription>
                </CardHeader>
                <CardContent className="flex-grow">
                  <ul className="space-y-4">
                    {benefits.filter(b => b.columnId === col.id).map((benefit, j) => <li key={j} data-index={j} className="flex items-start gap-3">
                          <Check className="size-5 text-chart-2 shrink-0 mt-0.5" />
                          <span className="text-muted-foreground leading-relaxed">
                            {benefit.text}
                          </span>
                        </li>)}
                  </ul>
                </CardContent>
              </Card>
            </div>)}
        </div>

        <div className="mt-20 flex justify-center">
          <Link to="/OralAppliancesPage">
            <Button size="lg" className="px-16 h-14 text-lg font-semibold shadow-lg hover:shadow-xl transition-all bg-chart-2 hover:bg-chart-2/90 text-white">
              See How It Works
            </Button>
          </Link>
        </div>
      </div>
    </section>;
}